import { useEffect } from "react";
/**
 * @param {boolean} toggle Element which toggles the lock
 */
const useBodyScrollLock = (toggle) => {
    useEffect(() => {
        if (toggle) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [toggle]);
};

export default useBodyScrollLock;
